import React, { useEffect, useMemo, useState } from "react";

export default function FadeIn({
  children,
  duration = 650,   // ms
  delay = 0,        // ms
  offsetY = 12,      // 初期の下方向オフセット(px)
  style = {},
  ...props
}) {
  const [shown, setShown] = useState(false);

  // ユーザーが「簡易アニメーション」を希望する場合の配慮
  const reduced = useMemo(() => {
    if (typeof window === "undefined" || !window.matchMedia) return false;
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }, []);

  useEffect(() => {
    const t = setTimeout(() => setShown(true), 10); // 初回描画後に起動
    return () => clearTimeout(t);
  }, []);

  const base = reduced
    ? {} // モーション削減時は静的表示
    : {
        opacity: shown ? 1 : 0,
        transform: shown ? "translateY(0)" : `translateY(${offsetY}px)`,
        transition: `opacity ${duration}ms ease, transform ${duration}ms ease`,
        transitionDelay: `${delay}ms`,
      };

  return (
    <div style={{ ...base, ...style }} {...props}>
      {children}
    </div>
  );
}